import type { Pinia } from 'pinia';

export const cloneSsrPiniaState = <T>(state: T): T => structuredClone(state);

let ssrPiniaSnapshot: Record<string, unknown> | undefined | null = null;

export const captureSsrPiniaSnapshot = (): void => {
  if (ssrPiniaSnapshot !== null) {
    return;
  }

  const piniaState = window.__PINIA_STATE__;
  ssrPiniaSnapshot = piniaState ? cloneSsrPiniaState(piniaState) : undefined;
};

export const resetSsrPiniaSnapshotForTests = (): void => {
  ssrPiniaSnapshot = null;
};

export const restorePiniaFromSsrSnapshot = (
  pinia: Pinia,
  piniaState: Record<string, unknown>,
): void => {
  pinia.state.value = cloneSsrPiniaState(piniaState) as typeof pinia.state.value;
};

export const getSsrPiniaSnapshot = (): Record<string, unknown> | undefined => {
  captureSsrPiniaSnapshot();

  return ssrPiniaSnapshot ? cloneSsrPiniaState(ssrPiniaSnapshot) : undefined;
};
